import { Pipe, PipeTransform } from "@angular/core";
import { GridColumn } from "../models/grid-definition.model";

@Pipe({
    name: 'visibleColumns',
    standalone: true
})
export class VisibleColumnsPipe implements PipeTransform {
  transform(columns: GridColumn[]) {
    return columns.filter(x => x.width != 0);
  }
}
